import React from 'react';

const Tick = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#3FB0E8">
        <g>
          <path
            d="M22.408.534l.118.115.107.123c.577.71.465 1.802-.277 2.407L8.194 14.7c-.602.489-1.465.525-2.11.102-.203-.124-.355-.255-.483-.412L.385 7.978l-.099-.134c-.455-.684-.36-1.608.23-2.188l.123-.113c.759-.616 1.895-.499 2.507.254L7.3 10.903 20.103.49c.677-.55 1.664-.517 2.305.045z"
            transform="translate(0 3) translate(.5 .906)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Tick;
